<script setup lang="ts">
import { ref } from 'vue';

import { PhxsgPicture } from '../../Atoms/Picture';
import { PhxsgText } from '../../Atoms/Text';

import { useColumnReveal } from './use-column-reveal';

import type { CollectionsBlockItem } from './phxsg-collections-block.vue';

const { items } = defineProps<{
  items: CollectionsBlockItem[];
}>();

const rootRef = ref<HTMLElement | null>(null);

useColumnReveal(rootRef);
</script>

<template>
  <div
    ref="rootRef"
    class="phxsg-collections-block-desktop phxsg-collections-block-desktop--alt phxsg-collections-block-desktop--static"
  >
    <div v-for="(item, index) in items" :key="`${item.title}-${index}`" class="phxsg-collections-block-desktop__column">
      <div class="phxsg-collections-block-desktop__content">
        <div class="phxsg-collections-block-desktop__thumbnail-image-wrapper">
          <PhxsgPicture v-bind="item.thumbnail" type="full" class="phxsg-collections-block-desktop__image" />
        </div>

        <div class="phxsg-collections-block-desktop__thumbnail-info">
          <PhxsgText v-if="item.cta" use="a" :href="item.cta.href" class="phxsg-collections-block-desktop__link">
            {{ item.title }}
          </PhxsgText>

          <PhxsgText v-else>{{ item.title }}</PhxsgText>
        </div>
      </div>
    </div>
  </div>
</template>
